import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosResponse } from 'axios'
import { useMemo } from 'react'

export const useGetLast6MonthAdvanceWebData = (): any => {
  const url = `/producer/analytics/getAdvancePotential?currentMonth=false&origem=WEB`
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)
  const nestedData = useMemo(() => data?.data.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      last6MonthWebData: nestedData,
      last6MonthWebDataLoading: isLoading,
      last6MonthWebDataError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}

export const useGetCurrentMonthAdvanceWebData = (): any => {
  const url = `/producer/analytics/getAdvancePotential?currentMonth=true&origem=WEB`
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)
  const nestedData = useMemo(() => data?.data.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      currentMonthWebData: nestedData,
      currentMonthWebDataLoading: isLoading,
      currentMonthWebDataError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}

export const useGetLast6MonthAdvanceTefData = (): any => {
  const url = `/producer/analytics/getAdvancePotential?currentMonth=false&origem=TEF`
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)
  const nestedData = useMemo(() => data?.data.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      last6MonthTefData: nestedData,
      last6MonthTefDataLoading: isLoading,
      last6MonthTefDataError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}

export const useGetCurrentMonthAdvanceTefData = (): any => {
  const url = `/producer/analytics/getAdvancePotential?currentMonth=true&origem=TEF`
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)
  const nestedData = useMemo(() => data?.data.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      currentMonthTefData: nestedData,
      currentMonthTefDataLoading: isLoading,
      currentMonthTefDataError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}
